import React from "react";

const ModalForm = ({modalOpen, handleModalStatus, name, handleName, submitNew, title}) => {
    return (
        <div
            className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 ${
                modalOpen ? '' : 'hidden'
            }`}
        >
            <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] max-w-md">
                <h2 className="text-xl font-bold text-gray-800 mb-4">Add {title}</h2>
                <label htmlFor="Input" className="block text-gray-700 font-medium mb-2">
                    {title} Name
                </label>
                <input
                    value={name}
                    onChange={handleName}
                    id="Input"
                    type="text"
                    className="w-full border border-gray-300 rounded-lg py-2 px-4 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-4"
                    placeholder={`Enter ${title} name`}
                />
                <div className="flex justify-end space-x-4">
                    <button
                        onClick={handleModalStatus}
                        className="bg-gray-300 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-300"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={submitNew}
                        className="bg-blue-500 text-white py-2 px-4 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
                    >
                        Add
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ModalForm;